import ApiHelper from '../../../../../utils/apiHelper';

export const getReportsMenuItems = async () => {
    const reportsMenuItem = {
        id: 'reportsMenuItems',
        title: 'Reports',
        type: 'group',
        children: []
    };
    try {
        const res = await ApiHelper.get('/api/reports/menu/');
        if (res && res.status === 200) {
            res?.data?.forEach((row) => {
                const typeKey = row.type?.toLowerCase?.() || '';
                let icon;

                try {
                    icon = require(`assets/images/${typeKey}_reports.png`);
                } catch (e) {
                    icon = null; // fallback if image not found
                }
                const child = {
                    id: typeKey + '-reportsMenuItems',
                    title: typeKey.charAt(0).toUpperCase() + typeKey.slice(1) + ' Reports',
                    type: 'collapse',
                    icon: icon,
                    children: []
                };
                row.child.forEach((child_row) => {
                    child.children.push({
                        id: 'reportsMenuItems-' + child_row.name,
                        title: child_row.name,
                        type: 'item',
                        url: typeKey + '-reports/' + child_row.urlname,
                        breadcrumbs: false,
                        required: {
                            group_admin: true,
                            server_admin: true,
                            org_admin: true,
                            user_admin: true,
                            reporting: 1
                        }
                    });
                });
                reportsMenuItem.children.push(child);
            });
            return reportsMenuItem;
        }
        return reportsMenuItem;
    } catch (error) {
        console.error('Error fetching reports menu:', error);
        return reportsMenuItem;
    }
};

export default { getReportsMenuItems };
